module.exports = __webpack_public_path__ + "img/vignettes-asso_0005_institut-de-lengagement.29fa6159.jpg";